// removed by extract-text-webpack-plugin
module.exports = {"navy":"#001d38","turquoiseBlue":"#00adbc","white":"#fff","black":"#000","error":"#b71c1c","cancel":"#f75b4a","success":"#7ed321"};